import { render, staticRenderFns } from "./FilterOptionTapirMk.vue?vue&type=template&id=1f54dfd0&scoped=true&"
import script from "./FilterOptionTapirMk.vue?vue&type=script&lang=js&"
export * from "./FilterOptionTapirMk.vue?vue&type=script&lang=js&"
import style0 from "./FilterOptionTapirMk.vue?vue&type=style&index=0&id=1f54dfd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f54dfd0",
  null
  
)

export default component.exports